<script lang="ts">
	import type { IEventFaqsItem } from '@api/EventFaqsApi';

	export let items: IEventFaqsItem[];

	$: structuredDataObject = {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		mainEntity: items?.map((item) => {
			const { question, answer } = item;
			return {
				'@type': 'Question',
				name: question,
				acceptedAnswer: {
					'@type': 'Answer',
					text: answer
				}
			};
		})
	};

	$: structuredDataJsonString = JSON.stringify(structuredDataObject, null, 2);
</script>

<svelte:element this="script" type="application/ld+json">
	<!-- eslint-disable -->
	{@html structuredDataJsonString}
</svelte:element>
